import nxModule from 'nxModule';

const templateUrl = require('./customer-landing-page.template.html');
nxModule.component('customerLandingPage', {
  templateUrl: templateUrl,
  controller: function () {}
});